export default __webpack_public_path__ + "assets/icon-refresh.df176bff.webp";